import * as yup from 'yup';

export const reviewSchema = yup
  .object()
  .shape({
    review: yup
      .string()
      .min(10, 'Must be at least 10 char')
      .max(500, 'Must be at most 500 char'),
    rating: yup.number()
  });
